import "./_noOffre.scss";

import Button from "@/components/Button/Button";

export function NoOffre(): JSX.Element {
  return (
    <div className="noOffre">
      <h1>💥 Aucune offre Cofaq disponible pour le moment ! 💥</h1>
      <p>
        Pas d'inquiétude, notre équipe déniche activement les meilleures
        opportunités pour vous.
      </p>
      <p>📢 Revenez bientôt et ne manquez pas nos offres exclusives !</p>
      <Button
        label="Retourner sur Extranet"
        variant="primary"
        onClick={() => (window.location.href = "https://extranet.cofaq.fr/")}
      />
    </div>
  );
}
